import { bool, elementType, string } from 'prop-types';

import { Message } from 'jl-design-system/components/message/Message';

import styles from './SuccessBookingMessage.scss';

export const SuccessBookingMessage = ({
  title = 'Thank you for booking with us',
  email,
  isBookingForSomeoneElse,
  isGift,
  isBookingRemote,
  within48h,
  price,
  SuccessBookingMessageParagraph = null,
  additionalDescription,
}) => {
  const content = [
    SuccessBookingMessageParagraph && (
      <SuccessBookingMessageParagraph
        isBookingForSomeoneElse={isBookingForSomeoneElse}
        isGift={isGift}
        price={price}
        within48h={within48h}
        key={`price${price}`}
      />
    ),
    <span key={`email${email}`}>
      A confirmation email will be sent to you shortly on
      {` ${email}`}.
    </span>,
    isBookingForSomeoneElse || isGift || isBookingRemote || (
      <span key={`additional${additionalDescription}`}>
        {additionalDescription || ' We look forward to seeing you.'}
      </span>
    ),
  ];

  return (
    <Message
      title={title}
      body={<div className={styles.SuccessBookingMessageBody}>{content.filter(Boolean)}</div>}
      className={styles.SuccessBookingMessage}
      type="success"
      wideTab
    />
  );
};

SuccessBookingMessage.propTypes = {
  email: string.isRequired,
  price: string.isRequired,
  title: string,
  isBookingForSomeoneElse: bool.isRequired,
  isGift: bool.isRequired,
  within48h: bool.isRequired,
  isBookingRemote: bool.isRequired,
  SuccessBookingMessageParagraph: elementType,
  additionalDescription: string,
};
